import { BookSectionSourceTypeActions } from './../ActionTypes';

export const setBookSectionSourceTypes = (bookSectionSourceTypes) => ({
    type: BookSectionSourceTypeActions.SetAll,
    bookSectionSourceTypes
});
